import { getCMKList } from '@/utils/cmk';
import { INIT_CMKS, UPDATE_CMK } from '../mutation-types';
import { SimpleAsyncProducerConsumer } from '@/utils/producerConsumer';
import { CMKInstance } from '@reolink-cloud/interface';

const state = {
    cmks: null,

    _cmkMap: null,

    _cmkIndexMap: null,

    _enforcedCMK: -1
};

interface ICMKState {
    cmks: any;
    _cmkMap: any;
    _cmkIndexMap: any;
    _enforcedCMK: number;
}

const mutations = {
    [INIT_CMKS]( state: ICMKState, cmks: ICMKState['cmks'] ): void {

        state.cmks = cmks;

        state._cmkMap = {};

        state._cmkIndexMap = {};

        state._enforcedCMK = -1;

        const cmkMap = state._cmkMap;

        const cmkIndexMap = state._cmkIndexMap;

        for ( let i = 0, len = cmks.length; i < len; i++ ) {

            const cmk = cmks[i];
            if ( cmk.status === 'enforced' ) {

                state._enforcedCMK = i;

            }
            const cmkId = cmk.id;
            cmkIndexMap[cmkId] = i;
            cmkMap[cmkId] = cmk;

        }

    },
    [UPDATE_CMK]( state: ICMKState, { id, cmk }: { id: string;cmk: CMKInstance; }): void {

        if ( !state._cmkIndexMap ) {

            return;

        }
        const index = state._cmkIndexMap[id];
        if ( index === void 0 ) {

            return;

        }
        state._cmkMap[id] = cmk;
        state.cmks[id] = cmk;

    }
};

const getCMKListProvider = new SimpleAsyncProducerConsumer( getCMKList );
const actions = {
    // 一个页面初始化(created)的时候，有多次使用获取 cmk 列表的接口时候，核心组件使用 getCMKS, 剩余的组件使用这个 initGetCMKS
    initGetCMKS: async ({ commit, state }: { commit: ( type: string, payload: any ) => void; state: ICMKState; }): Promise<void> => {

        const result = await getCMKListProvider.consumeGet();
        if ( state.cmks === result ) {

            return;

        }
        commit( INIT_CMKS, result );

    },
    getCMKS: async ({ commit }: { commit: ( type: string, payload: any ) => void; }, referenceCount: number ): Promise<void> => {

        commit( INIT_CMKS, await getCMKListProvider.providerGet( referenceCount ));

    }
};

const getters = {
    cmks: ( state: ICMKState ): ICMKState['cmks'] => state.cmks,

    cmkMap: ( state: ICMKState ): ICMKState['_cmkMap'] => state._cmkMap,

    enforcedCMK: ( state: ICMKState ): CMKInstance => state.cmks?.[state._enforcedCMK]
};

export default {
    state,
    getters,
    actions,
    mutations
};
